<template>
  <div
    :id="versionDomID"
    class="releaseListItem"
    data-automation="package-releases-versions-list"
    :class="{ active : isSelected }"
    style="padding-left: 5px; padding-right: 5px;"
    @click="handleClick"
  >
    <div :data-automation="versionID">
      {{ version }}
      <span style="padding: 4px;">
        <span
          v-if="showYanked"
          class="yanked"
        >
          YANKED
        </span>
      </span>
    </div>
    <div
      class="date"
      data-automation="available-release-distribution"
    >
      {{ distributions.length }} Available Distributions
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex'
import * as types from '../../store/mutation-types'

export default {
  name: 'ReleaseListItem',
  props: {
    version: {
      type: String,
      required: true,
    },
    distributions: {
      type: Array,
      required: true,
    },
  },
  data: function () {
    return {
      selected: false,
    }
  },
  computed: {
    ...mapState({
      selectedPackageVersion: state => state.packages.selectedPackageVersion,
    }),
    isSelected: function () {
      if (this.selectedPackageVersion) {
        return this.selectedPackageVersion === this.version
      }

      return false
    },
    versionDomID: function () {
      return `e2e-version-${this.version}`
    },
    versionID: function () {
      return `package-releases-${this.version}`
    },
    showYanked: function () {
      if (this.distributions.length === 0) {
        return false
      }

      for (let i = 0; i < this.distributions.length; i++) {
        if (!this.distributions[i].yanked) {
          return false
        }
      }

      return true
    },
  },
  methods: {
    handleClick: function (event) {
      this.$store.commit(types.SET_SELECTED_PACKAGE_VERSION, this.version)
      this.$store.commit(types.SET_SELECTED_PACKAGE_RELEASE_DISTRIBUTIONS, this.distributions)
    },
  },
}

</script>
